import { usePage } from "@inertiajs/react";

export default function useT(group = "site") {
    const { props } = usePage();
    const dictionary = props?.translations?.[group] || {};

    const t = (key, replacements = {}) => {
        let value = dictionary?.[key];

        if (typeof value !== "string" || value === "") {
            return key;
        }

        // Replace placeholders like :vacanciesCount with actual values
        Object.entries(replacements).forEach(([placeholder, replacement]) => {
            value = value.replace(new RegExp(placeholder, "g"), replacement);
        });

        return value;
    };

    return { t, dictionary };
}
